import React from "react";
import CfriShell from "./CfriShell";
import { ProvenanceTag } from "./CfriUI";
import { SectionCard } from "../funder/FunderUI";

// Items that describe engine-drafted text; everything else on this page is computed
const ENGINE_ITEMS = new Set(["Assessment and probe questions"]);

export default function CfriMethod() {
    return (
        <CfriShell active="method">
            {(content) => <Method content={content} />}
        </CfriShell>
    );
}

function Method({ content }) {
    const { method, readme, overview } = content;
    return (
        <div className="funder-section-stack" style={{ maxWidth: 860 }}>
            <div className="funder-page-header">
                <div className="funder-overline">Method</div>
                <h1 className="funder-h1">{method.title}</h1>
                {readme?.howToRead && <p className="funder-subtitle" style={{ margin: 0 }}>{readme.howToRead}</p>}
            </div>

            {method.items.map((item) => (
                <SectionCard key={item.label} title={item.label} right={<ProvenanceTag kind={ENGINE_ITEMS.has(item.label) ? "engine" : "computed"} />}>
                    <p className="cfri-body-text" style={{ margin: 0 }}>{item.text}</p>
                </SectionCard>
            ))}

            {readme?.handling && (
                <SectionCard title="Handling">
                    <p className="cfri-body-text" style={{ margin: 0 }}>{readme.handling}</p>
                </SectionCard>
            )}

            <p className="cfri-footnote">{overview.built}.</p>
        </div>
    );
}
